import { ICDNSize } from "~/interfaces";

const SIZES: { [key: string ]: ICDNSize } = {
	SIZE_40_40: { width: 40, height: 40 },
	SIZE_56_56: { width: 56, height: 56 }, // rozmer pro atlas
	SIZE_60_60: { width: 60, height: 60 },
	SIZE_80_52: { width: 80, height: 52 },
	SIZE_80_65: { width: 80, height: 65 },
	SIZE_80_80: { width: 80, height: 80 },
	SIZE_160_104: { width: 160, height: 104 },
	SIZE_112_112: { width: 112, height: 112 }, // rozmer pro atlas
	SIZE_160_130: { width: 160, height: 130 },
	SIZE_160_160: { width: 160, height: 160 },
	SIZE_176_100: { width: 176, height: 100 },
	SIZE_368_113: { width: 368, height: 113 },
	SIZE_400_225: { width: 400, height: 225 },
	SIZE_200_200: { width: 200, height: 200 },
	SIZE_300_300: { width: 300, height: 300 },
	SIZE_400_400: { width: 400, height: 400 },
	SIZE_500_500: { width: 500, height: 500 },
	SIZE_600_600: { width: 600, height: 600 },
	SIZE_667_500: { width: 667, height: 500 },
	SIZE_2200_2200: { width: 2200, height: 2200 },
};

function setSize(urlInput: string, size: ICDNSize, dynamicHeight = false, nocrop = false) {
	let url = urlInput || "";

	url = url.replace("{width}", size.width.toString());
	url = nocrop ? url.replace("{height},3", "{height},1") : url;
	url = url.replace("{height}", dynamicHeight ? "" : size.height.toString());

	return url;
}

export function getDetailSize() {
	return SIZES.SIZE_400_225;
}

export function getDetailImage(path: string, dynamicHeight = false): string {
	return setSize(path, getDetailSize(), dynamicHeight);
}

export function getImage80x80(path: string): string {
	return setSize(path, SIZES.SIZE_80_80);
}

export function getImage80x52(path: string): string {
	return setSize(path, SIZES.SIZE_80_52);
}

export function getImage160x130(path: string): string {
	return setSize(path, SIZES.SIZE_160_130);
}

export function getImage176x100(path: string): string {
	return setSize(path, SIZES.SIZE_176_100);
}

export function getImage2200x2200(path: string): string {
	return setSize(path, SIZES.SIZE_2200_2200);
}

export function getImage(path: string, width: number, height: number): string {
	return setSize(path, { width, height });
}
